import classNames from 'classnames';
import { Steps } from 'Components';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import React from 'react';
import './FormSteps.css';

const FormSteps = props => (
  <div className={classNames({ 'forms-steps__mobile': props.isMobile }, 'forms-steps')}>

    <Steps
      maxIndex={props.maxIndex}
      index={props.formIndex}
      steps={props.isNew && props.isOrder ? [props.steps[0]] : props.steps}
      onClick={props.onStepChange}
    />
    {props.isMobile &&
      <div className="forms-steps__label">
        <span>{props.formIndex + 1} {i18n.t('common:of')} {props.steps.length}: </span>
        <span>{i18n.t(`common:${props.steps[props.formIndex]}`)}</span>
      </div>
    }

  </div>
);

FormSteps.propTypes = {
  maxIndex: PropTypes.number,
  formIndex: PropTypes.number,
  isNew: PropTypes.bool,
  isOrder: PropTypes.bool,
  steps: PropTypes.arrayOf(PropTypes.string),
  onStepChange: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default FormSteps;



// WEBPACK FOOTER //
// ./src/components/FormSteps/FormSteps.jsx